export const roomAmenities = [
  'Kopalnica s tušem',
  'TV',
  'Brezžični internet (WiFi)',
  'Brisače',
  'Posteljnina',
];

export const rooms = [
  {
    id: 'dvoposteljna',
    name: 'Dvoposteljna soba',
    category: 'Dvoposteljna',
    size: '14 m²',
    capacity: '2 osebi',
    beds: 'Zakonska postelja',
    description:
      'Udobna soba za pare, ki iščejo mir in prijeten oddih v domačem vzdušju. Svetla, topla in opremljena za sproščeno bivanje.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/5d867f2f3cafc4c2fe28665be2db15e4.png',
  },
  {
    id: 'triposteljna',
    name: 'Triposteljna soba',
    category: 'Triposteljna',
    size: '21 m²',
    capacity: '3 osebe',
    beds: 'Zakonska in enojna postelja',
    description:
      'Prostorna soba, primerna za pare z otrokom ali manjšo družino. Dovolj prostora za udobno bivanje ob daljšem obisku.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/b99c8b5500c2e99bc28bca7acbfd487f.png',
  },
  {
    id: 'stiriposteljna',
    name: 'Štiriposteljna soba',
    category: 'Štiriposteljna',
    size: '23 m²',
    capacity: '4 osebe',
    beds: 'Zakonska in dve enojni postelji',
    description:
      'Naša najprostornejša soba, idealna za družine ali prijatelje na potovanju. Ponuja veliko prostora in miren počitek.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/b1dfffcc137f1ea45ca800114ffb1f75.png',
  },
];

export const roomsGallery = [
  {
    caption: 'Dvoposteljna soba',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/5d867f2f3cafc4c2fe28665be2db15e4.png',
  },
  {
    caption: 'Triposteljna soba',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/b99c8b5500c2e99bc28bca7acbfd487f.png',
  },
  {
    caption: 'Štiriposteljna soba',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/b1dfffcc137f1ea45ca800114ffb1f75.png',
  },
];